// extracted by mini-css-extract-plugin
export var table = "_wo-0";